import PostList from "./pages/ListPage.vue";
import PostDetail from "./pages/FormPage.vue";
import PostIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/post",
    component: PostIndex,
    redirect: "/post/list",
    name: "post",
    children: [
      {
        path: "list",
        component: PostList,
        name: "post.list",
      },
      {
        path: "create",
        component: PostDetail,
        name: "post.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: PostDetail,
        name: "post.edit",
        props: { create: false },
      },
    ],
  },
];
